import axios from 'axios';
import { mutate } from 'swr';

import { TTier } from '@modules/admin/Tools/LenderUtility/interfaces';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { newGridRecordId } from '@shared/commonFunctions';

export const requestUpsertTiers = async(lenderId: string, cardId = '', tier: TTier) => {
  const isNewRecord = tier?.id === newGridRecordId;
  const path = isNewRecord
    ? cardId && `/${SERVICES.LENDER}/lenders/${lenderId}/tier/${cardId}`
    : `/${SERVICES.LENDER}/lenders/${lenderId}/tier`;

  try {
    const resp = isNewRecord ? await axios.put(path, tier) : await axios.patch(path, tier);
    Notistack.successMessage(`Tier ${tier?.tierLabel} - ${isNewRecord ? 'Created' : 'Updated'} Successfully`);
    return resp.data;
  } catch (err) {
    const error = getError(err);
    Notistack.generalError(error);
    return { error };
  }
};

export const requestCopyTier = (lenderId: string, tierId = '') => {
  const path = tierId && `/${SERVICES.LENDER}/lenders/${lenderId}/tier-copy/${tierId}`;
  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async() => {
    try {
      await axios.post(path, path);
      Notistack.successMessage('Tier - Copied Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteTier = (lenderId: string, tierId = '') => {
  const path = tierId && `/${SERVICES.LENDER}/lenders/${lenderId}/tier/${tierId}`;
  return mutate(`/${SERVICES.LENDER}/lenders/${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('Tier - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
